import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import { ReactNode } from 'react';

import { mergeSxProps } from '~/utils/helpers/sxProps';

import { useSxStyles } from './useStyles';

type Props = {
  label: string;
  value?: string;
  children?: ReactNode | JSX.Element;
  variant?: 'row' | 'stacked';
  slotProps?: {
    root?: BoxProps;
    label?: BoxProps;
    value?: BoxProps;
  };
};

export const LegacyFieldReadMode = (props: Props) => {
  const sxStyles = useSxStyles();
  const { label, value, variant, children, slotProps } = props;

  return (
    <Box
      sx={mergeSxProps(sxStyles.root, slotProps?.root?.sx)}
      className={variant}
    >
      <Box sx={mergeSxProps(sxStyles.label, slotProps?.label?.sx)}>{label}</Box>
      <Box sx={mergeSxProps(sxStyles.value, slotProps?.value?.sx)}>
        {!!value ? value : children}
      </Box>
    </Box>
  );
};
